export default __webpack_public_path__ + "locales/cs/SingleSignOn.json?hash=cb999b43af16e10771a465aa00cf398c";